import React, { useRef, useState, useContext, useEffect, createContext, Fragment } from "react";
import { db } from '../firebase'
import {
  query,
  collection,
  onSnapshot,
  updateDoc,
  doc,
  addDoc,
  deleteDoc,
  setDoc,
} from 'firebase/firestore'
import { Listbox, Transition } from '@headlessui/react'
import Slider from 'react-input-slider'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { useParams } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { SessionContext, SceneContext, StoryContext } from '/AppStoryPlayer'
import GridSelect from "./CompGridSelect";
import { AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";

import { CompactPicker, ChromePicker, SketchPicker } from "react-color";

const ConfigFreeText = ({ contentItem }) => {

  const [valueLongText, setValueLongText] = useState();
  const { storyId } = useParams()
  const animationStyles = [
    { id: 1, name: 'none', displayName: 'None' },
    { id: 2, name: 'bounceIn', displayName: 'Bounce In' },
    { id: 3, name: 'fadeIn', displayName: 'Fade In' },
    { id: 4, name: 'fadeInDown', displayName: 'Fade In Down' },
    { id: 5, name: 'fadeInLeft', displayName: 'Fade In Left' },
    { id: 6, name: 'fadeInRight', displayName: 'Fide In Right' },
    { id: 7, name: 'fadeInUp', displayName: 'Fade In Up' },
    { id: 8, name: 'zoomIn', displayName: 'Zoom In' },
  ]

  useEffect(() => {
    if (contentItem) {
      setValueLongText(contentItem.content)
      // console.log('Content Item...')
      // console.log(contentItem)
    }
  }, [])

  const [storyData, setStoryData] = useContext(StoryContext)
  const [sceneData, setSceneData] = useContext(SceneContext)
  const [sessionData, setSessionData] = useContext(SessionContext)



  // const [personaName, setPersonaName] = useState(item.mediaItem.personaName)
  // const [personaRole, setPersonaRole] = useState(item.mediaItem.personaRole)
  // const [personaPosX, setPersonaPosX] = useState(item.item.personaPosX)
  // const [personaDetail, setPersonaDetail] = useState(item.mediaItem.personaDetail)

  const [personaPositionXY, setPersonaPositionXY] = useState({ x: contentItem.pos.x, y: contentItem.pos.y })
  const [personaSize, setPersonaSize] = useState({ width: contentItem.size.width, height: contentItem.size.height })
  const [personaDelay, setPersonaDelay] = useState(contentItem.animationDuration)
  const [personaAnimation, setPersonaAnimation] = useState(contentItem.animation)
  const [cardScale, setCardScale] = useState(contentItem.scale || 1)


  const mediaitem = contentItem

  // const handleSliderXChange = (value) => {
  //   setPersonaPosX(value)
  // }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  const updateContent = async (e) => {
    // console.log('Update Content...')
    // console.log(valueLongText)
    // console.log(contentItem)

    let cloneVizActive = []
    cloneVizActive = [...sceneData[sessionData.activeIndex].viznodes]

    cloneVizActive.forEach(item => {
      //console.log(item.guid)
      if ((contentItem.guid == item.guid)) {

        // position (this will lay out in a tl, tr, bl, br, center)

        //contentItem.position = (this will lay out in a tl, tr, bl, br, center)
        contentItem.pos = personaPositionXY
        contentItem.size = personaSize
        contentItem.animationDuration = personaDelay
        contentItem.animation = personaAnimation
        contentItem.content = valueLongText
        contentItem.scale = cardScale
      }
    })

    let activeSceneId = sceneData[sessionData.activeIndex].id
    const sceneRef = doc(db, 'stories', storyId, 'scenes', activeSceneId)

    updateDoc(sceneRef, {
      viznodes: cloneVizActive
    })
  }


  const setNewPos = (newPos) => {

    setPersonaPositionXY({ x: newPos.x, y: newPos.y })

    let cloneVizActive = []
    cloneVizActive = [...sceneData[sessionData.activeIndex].viznodes]
    cloneVizActive.forEach(item => {
      //console.log(item.guid)
      if ((contentItem.guid == item.guid)) {
        contentItem.pos = { x: newPos.x, y: newPos.y }
      }
    })

    let cloneSceneDataActive = []
    cloneSceneDataActive = [...sceneData]
    cloneSceneDataActive[sessionData.activeIndex].viznodes = cloneVizActive
    setSceneData(cloneSceneDataActive)

    const activeSceneId = sceneData[sessionData.activeIndex].id

    const sceneRef = doc(db, 'stories', storyId, 'scenes', activeSceneId);
    //await 
    updateDoc(sceneRef, {
      viznodes: cloneVizActive
    })
  }

  const modules = {
    toolbar: [
      // [{ header: [1, 2, 3, 4, 5, 6, false] }],
      // ["bold"],
      // [{ list: "ordered" }, { list: "bullet" }],
      // ["link"],

      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      //[{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      //['link', 'image', 'video'],
      ['link'],
      [{ color: [// Slate
         '#ffffff', '#e2e8f0', '#cbd5e1', '#94a3b8', '#64748b', '#475569', '#334155', '#1e293b', '#0f172a',
        // Gray
            '#e5e7eb', '#d1d5db', '#9ca3af', '#6b7280', '#4b5563', '#374151', '#1f2937', '#111827',
        // Zinc
          '#e4e4e7', '#d4d4d8', '#a1a1aa', '#71717a', '#52525b', '#3f3f46', '#27272a', '#18181b',
        // Neutral
          '#e5e5e5', '#d4d4d4', '#a3a3a3', '#737373', '#525252', '#404040', '#262626', '#171717',
        // Stone
        '#e7e5e4', '#d6d3d1', '#a8a29e', '#78716c', '#57534e', '#44403c', '#292524', '#1c1917',
        // Red
        '#fecaca', '#fca5a5', '#f87171', '#ef4444', '#dc2626', '#b91c1c', '#991b1b', '#7f1d1d',
        // Orange
        '#fed7aa', '#fdba74', '#fb923c', '#f97316', '#ea580c', '#c2410c', '#9a3412', '#7c2d12',
        // Amber
        '#fde68a', '#fcd34d', '#fbbf24', '#f59e0b', '#d97706', '#b45309', '#92400e', '#78350f',
        // Yellow
       '#fef08a', '#fde047', '#facc15', '#eab308', '#ca8a04', '#a16207', '#854d0e', '#713f12',
        // Lime
       '#d9f99d', '#bef264', '#a3e635', '#84cc16', '#65a30d', '#4d7c0f', '#3f6212', '#365314',
        // Green
       '#bbf7d0', '#86efac', '#4ade80', '#22c55e', '#16a34a', '#15803d', '#166534', '#14532d',
        // Emerald
        '#a7f3d0', '#6ee7b7', '#34d399', '#10b981', '#059669', '#047857', '#065f46', '#064e3b',
        // Teal
      '#99f6e4', '#5eead4', '#2dd4bf', '#14b8a6', '#0d9488', '#0f766e', '#115e59', '#134e4a',
        // Cyan
       '#a5f3fc', '#67e8f9', '#22d3ee', '#06b6d4', '#0891b2', '#0e7490', '#155e75', '#164e63',
        // Sky
      '#bae6fd', '#7dd3fc', '#38bdf8', '#0ea5e9', '#0284c7', '#0369a1', '#075985', '#0c4a6e',
        // Blue
   '#bfdbfe', '#93c5fd', '#60a5fa', '#3b82f6', '#2563eb', '#1d4ed8', '#1e40af', '#1e3a8a',
        // Indigo
     '#c7d2fe', '#a5b4fc', '#818cf8', '#6366f1', '#4f46e5', '#4338ca', '#3730a3', '#312e81',
        // Violet
    '#ddd6fe', '#c4b5fd', '#a78bfa', '#8b5cf6', '#7c3aed', '#6d28d9', '#5b21b6', '#4c1d95',
        // Purple
       '#e9d5ff', '#d8b4fe', '#c084fc', '#a855f7', '#9333ea', '#7e22ce', '#6b21a8', '#581c87',
        // Fuchsia
       '#f5d0fe', '#f0abfc', '#e879f9', '#d946ef', '#c026d3', '#a21caf', '#86198f', '#701a75',
        // Pink
      '#fbcfe8', '#f9a8d4', '#f472b6', '#ec4899', '#db2777', '#be185d', '#9d174d', '#831843',
        // Rose
       '#fecdd3', '#fda4af', '#fb7185', '#f43f5e', '#e11d48', '#be123c', '#9f1239', '#881337', '#3B89FF'
        ] }, { background: [] }],

      ['clean'],

    ]
  }



  const CompColorPicker = (props) => {
    const [colorVariable, setColorVariable] = useState('#000000')
    const [dataLoaded, setDataLoaded] = useState(false)

    useEffect(() => {
      // setDataLoaded(true)
      // if (storyData != null) {
      //   setColorVariable(storyData.uiStyle[props.styleName])
      // }
    }, [])

    const storeColor = (color) => {
      // if (color != undefined) {
      //   const storyRef = doc(db, 'stories', storyId)
      //   let cloneStory = storyData

      //   cloneStory['uiStyle'] =
      //   {
      //     ...cloneStory['uiStyle'],
      //     [props.styleName]: color
      //   }
      //   updateDoc(storyRef,
      //     cloneStory
      //   )
      // }
    }


    const preExpandedDesignGuid = ['backgroundEditorColor']


    return (

      <SketchPicker />


    )
  }




  return (
    // <form onSubmit={(e) => {
    //     e.preventDefault()
    // }}>
    <div className="">

      <div className='w-100p float-left slider-parent-size mt-1'>

        <div className=" h-200">
          <ReactQuill theme="snow"
            modules={modules}
            value={valueLongText} onChange={setValueLongText} />
        </div>


        <div className="flex mb-4 text-sm mt-4">
          <div className="flex-none w-20 h-4 text-gray-300 ml-1 mr-2">
            Width
          </div>
          <div className="flex-auto">
            <Slider
              axis="x"
              xmin={100}
              xmax={1600}
              xreverse={false}
              xstep={10}
              x={personaSize.width}
              onChange={({ x }) => setPersonaSize(state => ({ ...state, width: x }))}
              styles={{
                active: {
                  backgroundColor: '#333'
                },
                track: {
                  backgroundColor: '#1b1e21',
                  width: 180
                }
              }}
            />
          </div>
          <div className="flex-1 w-14 text-gray-300 ml-2">
            {personaSize.width}
          </div>
        </div>


        <div className="flex mb-4 w-full text-sm mt-4">
          <div className='grid grid-cols-5 gap-0 w-full '>
            <div id="" className="text-gray-300text-sm mt-2 text-left ml-1 mr-2">
              Scale
            </div>

            <div className='grid grid-cols-10 gap-0 col-span-3 ml-5'>
              <div className='col-span-3  p-2  text-center  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                onClick={(e) =>
                  //setCardScale(cardScale - .25)
                  cardScale > 0 ? setCardScale(cardScale - .25) : 0
                }
              >-</div>
              <div className='col-span-4'>
                <div className='className="block w-full rounded-md border-0  px-1.5 py-2 
text-white   sm:text-sm sm:leading-6 text-center'>
                  {cardScale}
                </div>
              </div>
              <div className='col-span-3 p-2  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                onClick={(e) => setCardScale(cardScale + .25)}
              >+</div>
            </div>
            <div className=" col-span-2 ">

            </div>
          </div>

        </div>


        <div className='flex w-full'>

          <div className='flex w-1/5 mr-4 text-gray-300 pt-3 text-sm ml-1 pr-3'>
            Animation
          </div>
          <div className='flex-auto'>
            <div className='grid grid-cols-5 gap-3 mt-1 mb-4  '>
              <div className='col-span-3'>
                <Listbox value={personaAnimation} onChange={setPersonaAnimation}>
                  {({ open }) => (
                    <>
                      <div className="relative  ">
                        <Listbox.Button className="relative w-full cursor-default rounded-md bg-white/5 py-2 pl-3 pr-10 text-left text-gray-200 shadow-sm ring-1 ring-inset ring-gray-900 focus:outline-none   sm:text-sm sm:leading-6
                            hover:bg-white/10
                            ">
                          <span className="block truncate">{personaAnimation.displayName || 'none'} &nbsp;</span>
                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                          </span>
                        </Listbox.Button>
                        <Transition
                          show={open}
                          as={Fragment}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-zinc-800 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {animationStyles.map((person) => (
                              <Listbox.Option
                                key={person.id}
                                className={({ active }) =>
                                  classNames(
                                    active ? 'bg-sky-500 text-white' : 'text-gray-300',
                                    'relative cursor-default select-none py-2 pl-3 pr-9'
                                  )
                                }
                                value={person}
                              >
                                {({ cardAnimation, active }) => (
                                  <>
                                    <span className={classNames(personaAnimation ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                      {person.displayName}
                                    </span>
                                    {cardAnimation ? (
                                      <span
                                        className={classNames(
                                          active ? 'text-white' : 'text-sky-600',
                                          'absolute inset-y-0 right-0 flex items-center pr-4'
                                        )}
                                      >
                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                      </span>
                                    ) : null}
                                  </>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
              <div className='col-span-2'>
                <div className='grid grid-cols-10 gap-0'>
                  <div className='col-span-3  p-2  text-center font-bold cursor-pointer bg-white/5 hover:bg-white/10 rounded'
                    onClick={(e) =>
                      //setPersonaDelay(personaDelay - 1)
                      personaDelay > 0 ? setPersonaDelay(personaDelay - 1) : 0
                    }
                  >-</div>
                  <div className='col-span-4'>
                    <div className='className="block w-full rounded-md border-0  px-1.5 py-2 
text-white   sm:text-sm sm:leading-6 text-center'>
                      {!personaAnimation.displayName ? 0 : personaDelay}
                    </div>
                  </div>
                  <div className='col-span-3 p-2 font-bold cursor-pointer text-center bg-white/5 hover:bg-white/10 rounded'
                    onClick={(e) => setPersonaDelay(personaDelay + 1)}
                  >+</div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </div>

      <div className='w-100p   mt-3'>

        {/* <Slider
          axis="xy"
          xmin={-30}
          xmax={30}
          ymin={-10}
          ymax={30}
          xreverse={true}
          yreverse={true}
          x={personaPositionXY.x}
          y={personaPositionXY.y}
          onChange={setPersonaPositionXY}
          styles={{
            active: {
              backgroundColor: '#333'
            },
            track: {
              backgroundColor: '#1b1e21'
            }
          }}
        /> */}


        <GridSelect
          //viznodes
          activeNode={
            contentItem.guid
            //'123'
          }
          viznodes={
            sceneData[sessionData.activeIndex].viznodes
            //sceneDataforGrid
          }
          setCardPositionXY={setNewPos}
        />

      </div>
      {/* <div className='text-white  mb-4'>
              Position {personaPositionXY.x}, {personaPositionXY.y}
            </div> */}



      <div className="sm:col-span-1 mt-6">
        <button className='w-full justify-center rounded-md bg-sky-500 px-3 py-1
                    text-l font-base text-white shadow-sm bg-sky-500 hover:bg-sky-400 focus-visible:outline
                    focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600' onClick={() => updateContent()}>Update</button>
      </div>
    </div>
    // </form>
  )
}

export default ConfigFreeText